import React, { Component } from 'react';
import PropTypes from 'prop-types';
import i18n from 'ar-i18n';
import DataTable from 'ar-data-table';
import DatePicker from 'ar-date-picker';
import { setReportingEndDate, setReportingStartDate,
         fetchAggregatePerformance, fetchDailyPerformance,
         fetchAggregateAttributions, fetchDailyAttributions } from '../actions.js';
import CsvDownloadButton from './CsvDownloadButton.jsx';
import { transformPerformanceData, renderCurrency, renderNumber, renderPercent } from '../utils/reporting.js';


class AggregatePerformanceTable extends Component {
    static propTypes = {
        i18nLoaded: PropTypes.bool,
        dispatch: PropTypes.func,
        advertisableEid: PropTypes.string,
        aggregatePerformance: PropTypes.object,
        aggregateAttributions: PropTypes.object,
        strategy: PropTypes.object,
        reportingStartDate: PropTypes.object,
        reportingEndDate: PropTypes.object
    };

    render() {
        const transformedData = [transformPerformanceData(this.props.strategy, this.props.aggregatePerformance, this.props.aggregateAttributions)];
        return (
            <div className='performance-reporting'>
                <div>
                    { this.renderReportingScheduleText() }
                </div>
                <div>
                    { this.renderDatePicker() }
                </div>
                <div className='download-csv-button'>
                    <CsvDownloadButton
                        columns={ this.getColumns(true) }
                        reportItems={ transformedData }
                        reportName='performance-overview'
                    />
                </div>
                <div>
                    <DataTable
                        columns={ this.getColumns() }
                        data={ transformedData }
                        i18n={ i18n }
                    />
                </div>
                <div>
                    { i18n.gettext('*We track CVs for 30days after clicks. All the columns after "CV", the values get updated for 30 days after the ad is clicked.') }
                </div>
                <div>
                    { i18n.gettext('*Overview does not include the last 4 days result. Please see the daily performance.') }
                </div>
            </div>
        );
    }

    renderDatePicker() {
        const reportingStartDate = i18n.moment.utc(this.props.reportingStartDate).format('YYYY-MM-DD'),
              reportingEndDate = i18n.moment.utc(this.props.reportingEndDate).format('YYYY-MM-DD'),
              today = i18n.moment.utc().format('YYYY-MM-DD');

        return (
            <div className='custom-reporting-period'>
                <DatePicker
                    buttons={ [] }
                    onChange={ this.handleDatePickerChange.bind(this) }
                    i18n={ i18n }
                    showTimeSelector={ false }
                    showHeadings={ false }
                    initialValue={ [reportingStartDate, reportingEndDate] }
                    disableBefore={ this.props.strategy.start_date }
                    disableAfter={ today }
                />
                <span className='utc-prompt'>{ i18n.gettext('UTC') }</span>
            </div>
        );
    }

    renderReportingScheduleText() {
        return (<div className='reporting-schedule-help'>
            { i18n.gettext('*This service is using UTC timezone.') }<br />
            { i18n.gettext('Eg; If you set end date as Nov-30, 2016, the actual stop timing will be Dec-1 9AM.') }<br />
            { i18n.gettext('Dec-1 0AM to 9AM is Nov-30 UTC based.') }<br />
            { i18n.gettext('So ad clicks happened during that period are going to be under November report.') }<br />
        </div>);
    }

    getColumns(forCsv = false) {
        return [{
            key: 'status',
            label: i18n.gettext('Status'),
            accessor: item => item.status,
            render: x => x
        }, {
            key: 'name',
            label: i18n.gettext('Campaign Name'),
            accessor: item => item.name,
            render: x => x,
            widthMultiplier: 2
        }, {
            key: 'spend',
            label: i18n.gettext('Spend'),
            accessor: item => item.spend,
            render: b => renderCurrency(b, forCsv)
        }, {
            key: 'clicks',
            label: i18n.gettext('Clicks'),
            accessor: item => item.clicks,
            render: x => renderNumber(x, forCsv)
        }, {
            key: 'ecpc',
            label: i18n.gettext('eCPC'),
            accessor: item => item.ecpc,
            render: b => renderCurrency(b, forCsv)
        }, {
            key: 'cv',
            label: i18n.gettext('CV'),
            accessor: item => item.conversions,
            render: x => renderNumber(x, forCsv)
        }, {
            key: 'cvr',
            label: i18n.gettext('CVR'),
            accessor: item => item.cvr,
            render: x => renderPercent(x)
        }, {
            key: 'gms',
            label: i18n.gettext('GMS'),
            accessor: item => item.gms,
            render: b => renderCurrency(b, forCsv),
            widthMultiplier: 2
        }, {
            key: 'cpa',
            label: i18n.gettext('CPA'),
            accessor: item => item.cpa,
            render: b => renderCurrency(b, forCsv),
            widthMultiplier: 2
        }, {
            key: 'roas',
            label: i18n.gettext('ROAS'),
            accessor: item => item.roas,
            render: x => renderPercent(x)
        }, {
            key: 'aov',
            label: i18n.gettext('AOV'),
            accessor: item => item.aov,
            render: b => renderCurrency(b, forCsv)
        }];
    }

    handleDatePickerChange(dateRange) {
        let [ startDate, endDate ] = dateRange;
        this.props.dispatch(setReportingStartDate(i18n.moment.utc(startDate)));
        this.props.dispatch(setReportingEndDate(i18n.moment.utc(endDate)));
        this.props.dispatch(fetchAggregatePerformance());
        this.props.dispatch(fetchDailyPerformance());
        this.props.dispatch(fetchDailyAttributions());
        this.props.dispatch(fetchAggregateAttributions());
    }

}

export default AggregatePerformanceTable;
